// ─────────────────────────────────────────────────────────────────────────────
// perception-score-chart.tsx
// ─────────────────────────────────────────────────────────────────────────────
import { AnalyticsChart } from "./analytics-chart";
import { MetricTerm }     from "../metric-term";
import { usePerceptionData } from "@/app/hooks/analytics/usePerceptionData";
import { getPerformanceEvents } from "@/app/data/performance-events";

interface Props {
  antennaData?:          any;
  selectedModels?:       string[];
  brandName?:            string;
  onNavigateToInsights?: () => void;
  projectionDate?:       string | null;
}

export function PerceptionScoreChart({ antennaData, selectedModels, brandName, onNavigateToInsights, projectionDate }: Props) {
  const { data, isLoading, error } = usePerceptionData("full", antennaData, selectedModels);
  const events = getPerformanceEvents(brandName);

  return (
    <AnalyticsChart
      timeSeriesData={data?.data ?? []}
      selectedModels={data?.selectedModels ?? []}
      isLoading={isLoading}
      error={error}
      metricUnit=""
      metricName="Your AI Index"
      insightContext="Your AI Index"
      brandName={brandName}
      onNavigateToInsights={onNavigateToInsights}
      projectionDate={projectionDate}
      events={events}
      isIllustrative={data?.isSynthetic}
      metricTitle={
        <MetricTerm
          definition="A composite metric measuring how AI models understand and represent your brand, scored 0–100 by each model from its own perspective."
          calculation="Each selected AI model is queried separately and asked to score the brand based on its own training data and knowledge. Values are averaged for the overall score."
          interpretation="Higher scores mean AI models have accurate, favorable, deep knowledge of your brand. Differences between models reveal which AI systems know your brand best."
          goodRange="70-79 Good, 80-89 Excellent, 90+ Outstanding. Below 70 indicates significant opportunity."
          onOpenAIChat={() => {}}
        >
          Your AI Index
        </MetricTerm>
      }
    />
  );
}